/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ItemFromJSON, ItemToJSON, } from './Item.js';
/**
 * Check if a given object implements the GetUserCommentsCommentDto interface.
 */
export function instanceOfGetUserCommentsCommentDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('employerId' in value) || value['employerId'] === undefined)
        return false;
    if (!('employerName' in value) || value['employerName'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    if (!('job' in value) || value['job'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('isOwnComment' in value) || value['isOwnComment'] === undefined)
        return false;
    return true;
}
export function GetUserCommentsCommentDtoFromJSON(json) {
    return GetUserCommentsCommentDtoFromJSONTyped(json, false);
}
export function GetUserCommentsCommentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'employerId': json['employerId'],
        'employerName': json['employerName'],
        'body': json['body'],
        'job': ItemFromJSON(json['job']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'isOwnComment': json['isOwnComment'],
    };
}
export function GetUserCommentsCommentDtoToJSON(json) {
    return GetUserCommentsCommentDtoToJSONTyped(json, false);
}
export function GetUserCommentsCommentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'employerId': value['employerId'],
        'employerName': value['employerName'],
        'body': value['body'],
        'job': ItemToJSON(value['job']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] === null ? null : (value['updatedAt']?.toISOString()),
        'isOwnComment': value['isOwnComment'],
    };
}
